import {
  ActionViewModel,
  ActionViewModelImplementation,
  durationInSecondsOrZero,
  Effector,
  secondsToDuration,
  uuidOrNewUuid,
} from "./ActionViewModel";
import { allEffectorsWithType, StartDelayInput } from "./utils";
import { PtoOn, QuickAction } from "protos/atk/activities";
import { PtoType, ptoTypeToJSON } from "protos/atk/enums";
import { RigEffectiveConfig } from "protos/atk/effective_config";
import { TFunction } from "i18next";
import EngagePtoIcon from "common/images/atk-actions/engage-pto.svg?react";
import React from "react";

class EngagePtoViewModel extends ActionViewModel<EngagePtoViewModel> {
  constructor(
    effector: Effector,
    startInStageIndex: number,
    startDelaySec: number,
    public actionId: string,
    public actionData: PtoOn
  ) {
    super(effector, true, startInStageIndex, startDelaySec);
  }

  override toQuickAction(_finalActionThisEffector: boolean): QuickAction {
    return {
      actionId: uuidOrNewUuid(this.actionId),
      startDelay: secondsToDuration(this.startDelaySec),
      ptoOn: this.actionData,
      carryOverIntoWorkTask: true,
    };
  }

  override actionCardTitle(
    t: TFunction,
    _rigEffectiveConfig: RigEffectiveConfig,
    stageIndex: number,
    _finalActionThisEffector: boolean
  ): string | undefined {
    if (stageIndex === this.startInStageIndex) {
      if (this.actionData.ptoType === PtoType.PTO_TYPE_FRONT) {
        return t(
          "views.autotractor.autonomousActivities.action.cardTitle.ptoEngageFront"
        );
      } else if (this.actionData.ptoType === PtoType.PTO_TYPE_REAR) {
        return t(
          "views.autotractor.autonomousActivities.action.cardTitle.ptoEngageRear"
        );
      } else {
        return t(
          "views.autotractor.autonomousActivities.action.cardTitle.ptoEngageUnknown",
          { ptoType: ptoTypeToJSON(this.actionData.ptoType) }
        );
      }
    }
  }

  override effectorBlockedByActionMessage(t: TFunction): string {
    return t(
      "views.autotractor.autonomousActivities.action.blockingMessage.ptoEngage"
    );
  }

  override components = ptoEngaged.components;
}
export const ptoEngaged: ActionViewModelImplementation<EngagePtoViewModel> =
  (() => {
    return {
      ActionButtonIcon: EngagePtoIcon,
      actionButtonLabelI18nKey:
        "views.autotractor.autonomousActivities.action.buttonLabel.ptoEngage",
      actionMenuSection: "holding-action",
      isNewActionAvailableForEffector: allEffectorsWithType("pto"),
      newAction: (effector, startInStageIndex) => {
        if (effector.type !== "pto") {
          throw new Error('ptoEngaged.newAction: effector type is not "pto"');
        }

        return new EngagePtoViewModel(effector, startInStageIndex, 0, "", {
          ptoType: effector.ptoType,
        });
      },
      fromQuickAction: (quickAction, startInStageIndex) => {
        if (quickAction.ptoOn) {
          return new EngagePtoViewModel(
            { type: "pto", ptoType: quickAction.ptoOn.ptoType },
            startInStageIndex,
            durationInSecondsOrZero(quickAction.startDelay),
            quickAction.actionId,
            quickAction.ptoOn
          );
        }
      },
      components: {
        Icon: EngagePtoIcon,
        EditForm: ({ basePath }) => {
          return (
            <div className="grid grid-cols-2 gap-2">
              <StartDelayInput path={basePath.startDelaySec} />
            </div>
          );
        },
      },
    };
  })();
